/**
 * Detecta se a URL atual é um subdomínio do domínio principal
 * @returns true se for um subdomínio, false caso contrário
 */
export const isSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  const tenantDomain = 'imobpanda.site';
  
  // Remove www. se presente
  const cleanHost = hostname.replace(/^www\./, '');
  
  // Se for o domínio principal, não é subdomínio
  if (cleanHost === tenantDomain) {
    return false;
  }
  
  // Se tem mais de 2 partes e termina com tenantDomain, é subdomínio
  const parts = cleanHost.split('.');
  if (parts.length >= 3 && cleanHost.endsWith(tenantDomain)) {
    return true;
  }
  
  return false;
};

/**
 * Extrai o subdomínio da URL atual
 * @returns O subdomínio ou null se não houver
 */
export const getSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  const tenantDomain = 'imobpanda.site';
  const cleanHost = hostname.replace(/^www\./, '');
  
  if (cleanHost === tenantDomain || cleanHost.includes('localhost')) {
    return null;
  }
  
  const parts = cleanHost.split('.');
  if (parts.length >= 3 && cleanHost.endsWith(tenantDomain)) {
    return parts[0];
  }
  
  return null;
};
